/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_VOUCHERS (state, vouchers) {
    state.vouchers = vouchers
  },
  REMOVE_RECORD (state, itemId) {
    const voucherIndex = state.vouchers.findIndex((u) => u.id === itemId)
    state.vouchers.splice(voucherIndex, 1)
  }
}
